<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="8" sm="10">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.purchaseOrders') }}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <purchase-orders-list :bus="bus" @itemSelected="itemSelected"></purchase-orders-list>
      </v-col>
    </v-row>

    <v-dialog v-model="isPurchaseOrderDetailDialogOpen" max-width="1600" persistent>
      <purchase-order-detail :purchaseOrderId="purchaseOrderSelected.id" :purchaseOrderNumber="purchaseOrderSelected.purchaseOrderNumber" :isActive="isPurchaseOrderDetailDialogOpen" @close="closeDetailDialog"></purchase-order-detail>
    </v-dialog>

    <v-dialog v-model="isPurchaseOrderMailDialogOpen" max-width="800" persistent>
      <purchase-order-mail :purchaseOrderId="purchaseOrderSelected.id" @close="closeMailDialog"></purchase-order-mail>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue'
import PurchaseOrderDetail from '../../components/PurchaseOrders/purchaseOrders/PurchaseOrderDetail'
import PurchaseOrdersList from '../../components/PurchaseOrders/purchaseOrders/PurchaseOrdersList'
import PurchaseOrderMail from '../../components/PurchaseOrders/purchaseOrders/PurchaseOrderMail'

export default {
  name: 'PurchaseOrdersPage',
  components: { PurchaseOrdersList, PurchaseOrderDetail, PurchaseOrderMail },
  data: () => ({
    bus: new Vue(),
    isPurchaseOrderDetailDialogOpen: false,
    isPurchaseOrderMailDialogOpen: false,
    purchaseOrderSelected: {}
  }),
  methods: {
    reloadData () {
      this.bus.$emit('reloadData')
    },
    itemSelected (item, action) {
      this.purchaseOrderSelected = Object.assign({}, item)
      switch (action) {
        case 'detail':
          this.isPurchaseOrderDetailDialogOpen = true
          break
        case 'mail':
          this.isPurchaseOrderMailDialogOpen = true
          break
      }
    },
    closeDetailDialog () {
      this.isPurchaseOrderDetailDialogOpen = false
      this.purchaseOrderSelected = {}
    },
    closeMailDialog () {
      this.isPurchaseOrderMailDialogOpen = false
      this.purchaseOrderSelected = {}
    }
  }
}
</script>

<style>

</style>
